import React from "react";
import TotoLabel from "@/components/toto/TotoLabel";
import TransitionGrammarStudy from "@/components/toto/TransitionGrammarStudy";

const teamGreen = "#5c8670";
const ink = "#273129";
const body = "#7a827b";
const line = "rgba(54,70,59,.09)";
const sans = '"Outfit",system-ui,-apple-system,BlinkMacSystemFont,sans-serif';
const serif = '"Cormorant Garamond",Georgia,"Times New Roman",serif';

const panel = {
  position: "relative",
  minHeight: 250,
  overflow: "hidden",
  border: `1px solid ${line}`,
  borderRadius: 24,
  background: "#eef4ef",
};

const surface = {
  position: "absolute",
  left: 22,
  right: 22,
  bottom: 22,
  minHeight: 104,
  padding: "16px 18px",
  border: "1px solid rgba(54,70,59,.10)",
  borderRadius: 20,
  backdropFilter: "blur(10px)",
  WebkitBackdropFilter: "blur(10px)",
  boxShadow: "inset 0 1px 0 rgba(255,255,255,.84)",
};

function PayrollObject({ active }) {
  return (
    <div style={{display:"flex",alignItems:"center",gap:14,position:"relative",zIndex:2}}>
      <div
        aria-hidden="true"
        style={{
          width:58,
          height:58,
          flex:"0 0 58px",
          borderRadius:"50% 48% 51% 49% / 49% 52% 48% 51%",
          background:active
            ? "radial-gradient(circle at 34% 27%,#ffffff 0%,rgba(252,253,252,.96) 34%,rgba(234,238,235,.92) 70%,rgba(198,205,200,.62) 100%)"
            : "radial-gradient(circle at 34% 27%,#ffffff 0%,rgba(229,244,234,.94) 26%,rgba(145,194,160,.96) 62%,rgba(92,134,112,.82) 100%)",
          boxShadow:active
            ? "inset -6px -7px 14px rgba(67,82,72,.055),0 8px 20px rgba(63,83,69,.07)"
            : "inset -8px -9px 16px rgba(54,93,68,.14),0 10px 28px rgba(63,104,77,.18)",
          transition:"background .8s ease, box-shadow .8s ease",
        }}
      />
      <div>
        <div style={{fontFamily:serif,fontSize:24,lineHeight:1,fontWeight:400,color:ink}}>Payroll</div>
        <div style={{marginTop:6,fontFamily:sans,fontSize:12.5,lineHeight:1.45,fontWeight:300,color:body}}>
          {active ? "Contents revealed" : "Contents held"}
        </div>
      </div>
    </div>
  );
}

function StatePanel({ active }) {
  return (
    <article style={panel}>
      <div style={{position:"absolute",inset:0,pointerEvents:"none",background:"radial-gradient(ellipse at 12% 8%,rgba(255,255,255,.62),transparent 30%)"}} />
      <div style={{position:"absolute",left:18,top:18}}>
        <TotoLabel style={{color:active?"#43624f":"#8a928b"}}>{active ? "Payroll Active" : "At Rest"}</TotoLabel>
      </div>
      <div
        style={{
          ...surface,
          overflow:"hidden",
          borderColor:active?"rgba(92,134,112,.26)":"rgba(54,70,59,.10)",
          background:active?"rgba(218,237,224,.76)":"rgba(250,252,250,.72)",
          boxShadow:active
            ? "inset 0 1px 0 rgba(255,255,255,.76),0 14px 34px rgba(63,104,77,.10)"
            : surface.boxShadow,
        }}
      >
        {active && (
          <>
            <div
              aria-hidden="true"
              style={{
                position:"absolute",
                inset:-34,
                background:"radial-gradient(ellipse at 24% 52%,rgba(92,134,112,.42) 0%,rgba(92,134,112,.22) 30%,rgba(92,134,112,.10) 54%,rgba(92,134,112,.03) 72%,transparent 84%)",
                filter:"blur(18px)",
                pointerEvents:"none",
              }}
            />
            <div
              aria-hidden="true"
              style={{
                position:"absolute",
                inset:0,
                background:"linear-gradient(90deg,rgba(255,255,255,.15),rgba(92,134,112,.06) 48%,rgba(255,255,255,.10))",
                pointerEvents:"none",
              }}
            />
          </>
        )}
        <PayrollObject active={active} />
      </div>
    </article>
  );
}

export default function CausalEnvironmentStudy() {
  return (
    <>
      <section style={{marginTop:30,paddingTop:22,borderTop:`1px solid ${line}`}}>
        <TotoLabel>Environment Response</TotoLabel>
        <div style={{marginTop:9,maxWidth:760,fontFamily:sans,fontSize:13,lineHeight:1.58,fontWeight:300,color:body}}>
          At rest, the vessel contains the subject's color while the surface stays neutral. When the relationship opens, the vessel releases that color into the working surface and becomes visually quiet.
        </div>
        <div style={{marginTop:14,display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
          <StatePanel active={false} />
          <StatePanel active />
        </div>
        <div style={{marginTop:12,display:"flex",alignItems:"center",gap:8}}>
          <span style={{width:8,height:8,borderRadius:"50%",background:teamGreen,boxShadow:"0 0 0 4px rgba(92,134,112,.10)"}} />
          <TotoLabel>Color Moves With Revealed Meaning</TotoLabel>
        </div>
      </section>
      <TransitionGrammarStudy />
    </>
  );
}
